// Catálogo de papéis de notificação conhecidos pelo sistema — usados para rotear
// alertas automáticos (Pedido Aprovado, Orçamento Estourado, Margem Crítica, relatórios
// agendados) sem precisar digitar/editar nada além de marcar a caixa do papel desejado.
export const PAPEIS_NOTIFICACAO_CATALOGO = [
  { valor: 'financeiro', label: 'Financeiro' },
  { valor: 'gestor', label: 'Gestor' },
];

// Une o catálogo conhecido com quaisquer papéis já em uso (vindos de
// GET /api/users/papeis-disponiveis), para não esconder personalizações antigas.
export function listaCompletaPapeis(papeisEmUso = []) {
  const conhecidos = new Set(PAPEIS_NOTIFICACAO_CATALOGO.map((p) => p.valor));
  const extras = (papeisEmUso || [])
    .filter((p) => p && !conhecidos.has(p))
    .map((p) => ({ valor: p, label: p.charAt(0).toUpperCase() + p.slice(1) }));
  return [...PAPEIS_NOTIFICACAO_CATALOGO, ...extras];
}
